import { StyledOptionLabel } from '../styled';
import { ExtendedLookupSearchValueOption } from '../types';

const getOptionForValue = (searchValue?: string): ExtendedLookupSearchValueOption => ({
    label: (
        <StyledOptionLabel>
            {searchValue}
        </StyledOptionLabel>
    ),
    isSearchOption: true,
    value: searchValue,
});

export default getOptionForValue;
